import {useQuery, useMutation, useQueryClient} from "@tanstack/react-query";
import {useEffect, useState, useContext} from 'react';
import {getProducts, addProductAddOn} from "../../api/api";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {toast} from "react-toastify";
import AuthContext from "../../context/AuthContext";
import Avatar from 'react-avatar';
import {
    Button,
    Col,
    Form,
    Input,
    Modal,
    ModalBody,
    ModalHeader,
    Row
} from "reactstrap";
import Loader from "../../components/Loader";
import RecordsNotFound from "../../components/RecordsNotFound";
import {Link} from "react-router-dom";
import handleUnauthorized401MutateError from "../../utils/handleUnauthorized401MutateError";
import Paginator from "../../components/Paginator";

function ProductItemList(props) {
    const {refreshToken} = useContext(AuthContext);
    const [page, setPage] = useState(1);
    const [productName, setProductName] = useState("");
    const [queryKey, setQueryKey] = useState(['products', page]);
    const queryClient = useQueryClient();
    const productStatus = "ACTIVE";
    const records = 9;
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedAddOns, setSelectedAddOns] = useState([]);

    useEffect(() => {
        setQueryKey(['products', page]);
    }, [page]);

    const {status, data, error, isFetching, refetch} = useQuery({
        queryKey: queryKey,
        queryFn: () => getProducts(page, '', productName, '', '', '', '', '', '', '', '', '', productStatus, '', '', records),
        keepPreviousData: true,
        retry: false,
        onError: (err) => {
            handleUnauthorized401QueryError(err, refreshToken, refetch);
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`);
            }
        },
    });

    const productAddOnMutation = useMutation({
        mutationFn: addProductAddOn,
        onSuccess: () => {
            queryClient.invalidateQueries(['cart']);
            if (!toast.isActive('cartItemAddedToast')) {
                toast.success('Cart Item Added!', { toastId: 'cartItemAddedToast' });
            }
        },
        // onError: (err, variables) => {
        //     handleUnauthorized401MutateError(err, refreshToken, productAddOnMutation, variables);
        //     let errorMessage = 'An unexpected error occurred.';
        //     console.log("someeeeeeeeee thinggggggggggg")
        //
        //     if (err.response && err.response.data) {
        //         const customerErrors = err.response.data['customer'];
        //         const nonFieldErrors = err.response.data.non_field_errors;
        //
        //         if (err.response.status === 400 && (customerErrors && (customerErrors[0] === "Object with email=undefined does not exist." || customerErrors[0] === "This field may not be null."))) {
        //             errorMessage = 'Please select a customer!';
        //         } else if (nonFieldErrors && nonFieldErrors.length > 0) {
        //             errorMessage = nonFieldErrors[0];
        //         }
        //     }
        //
        //     toast.error(errorMessage);
        // }
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, productAddOnMutation, variables);
            let errorMessage = err?.response?.data?.detail || 'An unexpected error occurred.';
            console.log("someeeeeeeeee thinggggggggggg", err.response.data['add_on_products'])

            if (err.response && err.response.data) {
                const customerErrors = err.response.data['customer'];



            }


            if (err.response && err.response.data) {
                const customerErrors = err.response.data['customer'];
                const addOnProductsErrors = err.response.data['add_on_products'];
                const nonFieldErrors = err.response.data.non_field_errors;

                if (err.response.status === 400 && (customerErrors && (customerErrors[0] === "Object with email=undefined does not exist." || customerErrors[0] === "This field may not be null."))) {
                    errorMessage = 'Please select a customer!';
                } else if (nonFieldErrors && nonFieldErrors.length > 0) {
                    errorMessage = nonFieldErrors[0];
                } else if (addOnProductsErrors){
                    errorMessage = addOnProductsErrors[0]
                }
            }

            toast.error(errorMessage);
        }
    });

    const handleProductItemClick = async (e, product) => {
        console.log("in handleProductItemClick")
        if (product.add_ons_supported.count !== 0) {
            console.log("Inside if")
            setSelectedProduct(product);
        } else {
            console.log("Inside else")
            const formData = new FormData();
            formData.append("product", product.id);
            formData.append("customer", props.customer);
            productAddOnMutation.mutate(formData);
            closeModal();
        }
    };

    const handleAddOnProductSubmit = async (e, product, addOns = []) => {
        const formData = new FormData();
        formData.append("product", product.id);
        formData.append("customer", props.customer);
        if (addOns.length > 0) {
            addOns.forEach(addOnId => {
                formData.append("add_on_products", addOnId);
            });
        }
        productAddOnMutation.mutate(formData);
        closeModal();
    }


    const handleProductSearch = (e, name) => {
        e?.preventDefault();
        setPage(1);
        setProductName(name);
        setQueryKey(['products', page, '', name, '', '', '', '', '', '', '', '', '', records]);
    };

    const handleAddOnClick = (addOnProduct) => {
        setSelectedAddOns(prevSelected => {
            if (prevSelected.includes(addOnProduct.id)) {
                return prevSelected.filter(id => id !== addOnProduct.id);
            } else {
                return [...prevSelected, addOnProduct.id];
            }
        });
    };

    const isAddOnSelected = (addOnProduct) => selectedAddOns.includes(addOnProduct.id);

    const closeModal = () => {
        setSelectedProduct(null);
        setSelectedAddOns([]);
    };

    return (
        <>
            {status === 'loading' && <Loader size={'default'} />}

            {status === 'success' | error?.response?.status === 401 && (
                <>
                    <div className="row">
                        <div className="col-sm-12 mb-2">
                            <Form onSubmit={(e) => handleProductSearch(e, productName)}>
                                <Row className="form-row align-items-center">
                                    <Col>
                                        <Input
                                            id="name"
                                            name="name"
                                            type="text"
                                            placeholder="Search Products..."
                                            className="form-control mb-2"
                                            // onChange={(e) => setProductName(e.target.value)}
                                            onChange={(e) => handleProductSearch(e, e.target.value)}
                                            value={productName}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </div>

                        {data?.count > 0 ? data?.results?.map(product => (
                            <div className="col-lg-4" key={product.id}>
                                <Link>
                                    <div
                                        className={`card ribbon-box ${product.stock === 0 ? 'out-of-stock' : ''}`}
                                        style={{ background: "#202027", pointerEvents: product.stock === 0 ? 'none' : 'auto' }}
                                        onClick={(e) => handleProductItemClick(e, product)}
                                    >
                                        {product.add_ons_supported.count > 0 && (
                                            <div className="ribbon-two ribbon-two-secondary">
                                                <span>{product.add_ons_supported.count} Add-On</span>
                                            </div>
                                        )}
                                        {product.stock === 0 && (
                                            <div className="ribbon-two ribbon-two-danger">
                                                <span className="stock-banner">Out of Stock</span>
                                            </div>
                                        )}
                                        <div className="box-details">
                                            {product.image ?
                                                <img src={product.image} className="card-img-top img-fluid box-image" alt="product group" />
                                                :
                                                <Avatar name={product.name} size="205" round={false} className="list-avatar"/>
                                            }
                                        </div>
                                        <div className="card-body" style={{ background: "#202027" }}>
                                            <h5 className="card-title" data-toggle="tooltip" data-placement="top" title={product.name}>
                                                {product.name.length > 15 ? `${product.name.slice(0, 13)}...` : product.name}
                                            </h5>
                                            <p className="card-text">INR {product.price}</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )) : <RecordsNotFound />}
                    </div>

                    {selectedProduct && (
                        <Modal className={'modal-lg'} isOpen={true} toggle={closeModal}>
                            <ModalHeader toggle={closeModal} close={
                                <button className="close" onClick={closeModal}>
                                    &times;
                                </button>
                            }>Product details: {selectedProduct.name}</ModalHeader>
                                <ModalBody>
                                    <Row>
                                        {selectedProduct?.add_ons_supported?.add_on_products.map(addOnProduct => (
                                            // <div className="card-box">
                                            //     <h4 className="header-title">hello</h4>
                                            //     <p className="sub-header">{addOnProduct.name}</p>
                                            // </div>
                                            <Col lg="4" key={addOnProduct.id}>
                                                <Link>
                                                    <div
                                                        className={`card ribbon-box ${isAddOnSelected(addOnProduct) ? 'border border-primary' : ''} ${addOnProduct.stock === 0 ? 'out-of-stock' : ''}`}
                                                        style={{ background: "#202027", pointerEvents: addOnProduct.stock === 0 ? 'none' : 'auto' }}
                                                        onClick={() => handleAddOnClick(addOnProduct)}
                                                    >
                                                        {addOnProduct.stock === 0 && (
                                                            <div className="ribbon-two ribbon-two-danger">
                                                                <span className="stock-banner">Out of Stock</span>
                                                            </div>
                                                        )}
                                                        <div className="box-details">
                                                        {addOnProduct.image ? <img src={addOnProduct.image} className="card-img-top img-fluid box-image" alt="product" />
                                                            : <Avatar name={addOnProduct.name} size="240" round={false} className="addon-avatar" />}
                                                        </div>
                                                        <div className="card-body" style={{ background: "#202027" }}>
                                                            <h5 className="card-title" data-toggle="tooltip" data-placement="top" title={addOnProduct.name}>{addOnProduct.name}</h5>
                                                            <p className="card-text">INR {addOnProduct.price}</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </Col>
                                        ))}
                                        {/*{selectedProduct.add_ons_supported.count}*/}
                                    </Row>
                                    <div className="mt-3 text-md-right">
                                        <Button onClick={(e) => handleAddOnProductSubmit(e, selectedProduct, selectedAddOns)} color="primary" disabled={productAddOnMutation.isLoading}>{productAddOnMutation.isLoading? <><Loader size={'small'}/>Adding to Cart...</>: `Add to Cart`}</Button>
                                    </div>
                                </ModalBody>

                        </Modal>
                    )}

                    <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                </>
            )}
        </>
    );
}

export default ProductItemList;
